import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { TicketList } from '@/components/support/ticket-list';
import { MessageSquare, Plus } from 'lucide-react';

export default function AdminSupportPage() {
  return (
    <div className="container py-8 px-4 md:px-6">
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold">Support Dashboard</h1>
            <p className="text-muted-foreground">
              Manage support tickets and customer inquiries
            </p>
          </div>
          <Button>
            <Plus className="h-4 w-4 mr-2" />
            Create Ticket
          </Button>
        </div>

        {/* Support Overview */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <Card>
            <CardContent className="p-6">
              <div className="flex justify-between items-center">
                <div>
                  <p className="text-sm font-medium text-muted-foreground">Open Tickets</p>
                  <h3 className="text-2xl font-bold mt-2">12</h3>
                </div>
                <Badge variant="secondary">4 urgent</Badge>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="p-6">
              <div className="flex justify-between items-center">
                <div>
                  <p className="text-sm font-medium text-muted-foreground">Avg Response Time</p>
                  <h3 className="text-2xl font-bold mt-2">2.5h</h3>
                </div>
                <Badge className="bg-green-100 text-green-800">On Target</Badge>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="p-6">
              <div className="flex justify-between items-center">
                <div>
                  <p className="text-sm font-medium text-muted-foreground">Resolution Rate</p>
                  <h3 className="text-2xl font-bold mt-2">94%</h3>
                </div>
                <Badge className="bg-green-100 text-green-800">+2.1%</Badge>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="p-6">
              <div className="flex justify-between items-center">
                <div>
                  <p className="text-sm font-medium text-muted-foreground">Customer Satisfaction</p>
                  <h3 className="text-2xl font-bold mt-2">4.8/5</h3>
                </div>
                <Badge className="bg-green-100 text-green-800">+0.2</Badge>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Tickets List */}
        <Card>
          <CardHeader>
            <CardTitle>Support Tickets</CardTitle>
            <CardDescription>
              View and manage customer support tickets
            </CardDescription>
          </CardHeader>
          <CardContent>
            <TicketList />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}